import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2022 - 2023</p>
          <h2 className="text-3xl md:text-4xl font-bold">Work & Study Experiences</h2>
        </div>
        <div className=" lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col mt-5 gap-6 flex-grow">
          <ResumeCard
            title="Alterra Academy"
            subTitle="How To Be An Ideal Top Search ReactJS Front-End"
            result="Kota Malang"
            des={
            <>
              <ul>
                <li>- Mempelajari pengembangan web menggunakan pustaka React JS yang responsif</li>
                <li>- Mengambil data dari API, dasar-dasar Front End, menguasai front end dengan React, GraphQL, dan kompetensi coding.</li>
                <li>- Mempelajari Bahasa Pemograman Javascript seperti conditional, function, asynchronous, fetching data API (fetch dan axios)</li>
                <li>-Project : Todolist, Website Penitipan Anak, Website Sewa Ruang Kantor (OfficeZone).</li>
              </ul>
            </>
            }
          />
          <ResumeCard
            title="Digital Talent Scholarship Kominfo X Cisco Networking Academy"
            subTitle="Fresh Graduate Academy Big Data Using Python"
            result="Jakarta"
            des={
            <>
              <ul>
                <li>- Mempelajari tentang Internet of Things (IoT)Machine Learning, dan Data Analysis dengan Python</li>
                <li>- Mempelajari modules dan package pada Python</li>
                <li>- Mempelajari Bahasa Pemograman Javascript seperti conditional, function, asynchronous, fetching data API (fetch dan axios)</li>
                <li>- Mempelajari penggunaan Bahasa Pemograman Python</li>
              </ul>
            </>
            }
          />
          <ResumeCard
            title="PT. Impactbyte Teknologi Edukasi (Skilvul)"
            subTitle="Skilvul Tech4Impact: Front-End Web Development"
            result="Jakarta"
            des={
            <>
              <ul>
                <li>- Skilvul Tech4Impact: Front-End Web Development</li>
                <li>- Menggunakan Figma untuk pembuatan wireframe, user flow, desain UI, dan prototyping</li>
                <li>- Mempelajari Bahasa Pemograman Javascript untuk pengembangan Front-End aplikasi website</li>
                <li>- Mempelajari pengembangan web Front-End menggunakan library Javascript React.js (hooks, manajemen state redux, pengambilan
                  data, fetching data API dengan fetch dan axios)</li>
                <li>- Projek Individu: Aplikasi ToDo List website, BMI Calculator</li>
                <li>- Projek akhir yang terdiri dari 5 pengembang, terdiri dari 3 frontend dan 2 backend, untuk menyelesaikan proyek akhir. Belajar
                  bertanggung jawab dan tepat waktu penugasan, Berkerja sama dengan tim untuk menyelesaikan projek aplikasi “Peduli Krisis Iklim
                  berbasis Website</li>
                <li>- Mendapatkan penghargaan juara 3 kelompok terbaik DemoDay</li>
              </ul>
            </>
            }
          />
          <ResumeCard
            title="BMKG Kota Tegal"
            subTitle="Web Development Intern"
            result="Kota Tegal"
            des={
            <>
              <ul>
                <li>Mampu bekerja sama dengan tim BMKG Kota Tegal, disiplin, dan bertanggung jawab menyelesaikan tugas tepat waktu. Membuat
                sistem pelayanan berbasis website untuk pelayanan BMKG Kota Tegal, dan Memperbarui company profile.</li>
              </ul>
            </>
            }
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
